/* eslint-disable @typescript-eslint/ban-ts-ignore, @typescript-eslint/no-explicit-any */
export default function forms() {
    var inputs = document.querySelectorAll('[data-form-input]');
    var fileUploads = document.querySelectorAll('[data-file-upload]');
    var shrinkLabel = function (label) {
        label.classList.add('shrink');
    };
    var growLabel = function (input, label) {
        if (input.value === '') {
            label.classList.remove('shrink');
        }
    };
    var showFileNames = function (event) {
        var e = event;
        var target = e.target;
        if (!target)
            return;
        var id = target.id;
        var infoArea = !!id && document.querySelector("[data-id=".concat(id, "]"));
        var files = target.files;
        if (infoArea) {
            infoArea.textContent = '';
        }
        files &&
            Array.from(files).forEach(function (file) {
                var name = file.name;
                var el = document.createElement('P');
                el.textContent = name;
                if (infoArea) {
                    infoArea.append(el);
                }
            });
    };
    inputs.forEach(function (input) {
        var inputId = input.getAttribute('id');
        if (!inputId)
            return;
        var label = document.querySelector("label[for=\"".concat(inputId, "\"]"));
        if (!label)
            return;
        input.addEventListener('focus', function () { return shrinkLabel(label); });
        input.addEventListener('blur', function () { return growLabel(input, label); });
    });
    fileUploads.forEach(function (fileUpload) {
        // @ts-ignore the right event
        fileUpload.addEventListener('change', showFileNames);
    });
}
